import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '@/context/AppContext';
import { PageHeader, Card } from '@/components/common';
import { HealthGauge, MiniBar } from '@/components/HealthGauge';
import { LineChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis, CartesianGrid } from 'recharts';
import { months } from '@/data/mockData';

const CompanyHealth = () => {
  const { t, tx, lang, data } = useApp();
  const h = data.health;

  return (
    <div>
      <PageHeader title={t('health.title')} subtitle={t('health.subtitle')} />
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-5">
        <Card className="lg:col-span-4 p-6 flex flex-col items-center" data-testid="health-score-card">
          <p className="text-[11px] tracking-[0.2em] uppercase font-semibold text-zinc-400 mb-4 self-start">{t('health.score')}</p>
          <HealthGauge score={h.score} label={tx(h.label)} size={230} />
        </Card>

        <Card className="lg:col-span-8 p-6" data-testid="health-dimensions">
          <p className="text-[11px] tracking-[0.2em] uppercase font-semibold text-zinc-400 mb-5">{tx({ es: 'Dimensiones', en: 'Dimensions' })}</p>
          <div className="grid sm:grid-cols-2 gap-x-8 gap-y-5">
            {h.dimensions.map((d, i) => (
              <motion.div key={d.key} initial={{ opacity: 0, y: 8 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
                <div className="flex items-center justify-between mb-1.5">
                  <span className="text-sm font-medium text-zinc-700">{t(`health.${d.key}`)}</span>
                  <span className="font-mono-num text-sm font-semibold text-zinc-900">{d.value}</span>
                </div>
                <MiniBar value={d.value} />
                <p className="text-xs text-zinc-400 mt-1.5">{tx(d.desc)}</p>
              </motion.div>
            ))}
          </div>
        </Card>

        <Card className="lg:col-span-12 p-6" data-testid="health-trend">
          <p className="text-[11px] tracking-[0.2em] uppercase font-semibold text-zinc-400 mb-4">{t('health.trend')}</p>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={h.trend} margin={{ left: -20, right: 10, top: 10 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f1f3" vertical={false} />
                <XAxis dataKey="i" tickFormatter={(i) => months[lang][i]} tick={{ fontSize: 11, fill: '#a1a1aa' }} axisLine={false} tickLine={false} />
                <YAxis domain={[40, 100]} tick={{ fontSize: 11, fill: '#a1a1aa' }} axisLine={false} tickLine={false} />
                <Tooltip contentStyle={{ borderRadius: 12, border: '1px solid #e4e4e7', fontSize: 12 }} labelFormatter={(i) => months[lang][i]} />
                <Line type="monotone" dataKey="score" stroke="#06B6D4" strokeWidth={3} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default CompanyHealth;
